import { render, staticRenderFns } from "./result-confirm.vue?vue&type=template&id=261c7031&scoped=true"
import script from "./result-confirm.vue?vue&type=script&lang=js"
export * from "./result-confirm.vue?vue&type=script&lang=js"
import style0 from "./result-confirm.vue?vue&type=style&index=0&id=261c7031&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261c7031",
  null
  
)

export default component.exports